import React, { useState } from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core";
import { RadioButtonUnchecked } from "@material-ui/icons";

function StepTrackerCorporate(props) {
  const { classes, step } = props;

  return (
    <div className={classes.trackerContainer}>
      <div className={`step ${step >= 1 ? "activeStep" : ""}`}>
        {step === 1 ? (
          <RadioButtonUnchecked classes={{ root: classes.circle }} />
        ) : (
          ""
        )}
        <div className="number">
          <span>1</span>
        </div>
      </div>
      <div className={`line ${step > 1 ? "activeLine" : ""}`}></div>
      <div className={`step ${step >= 2 ? "activeStep" : ""}`}>
        {step === 2 ? (
          <RadioButtonUnchecked classes={{ root: classes.circle }} />
        ) : (
          ""
        )}
        <div className="number">
          <span>2</span>
        </div>
      </div>
      <div className={`line ${step > 2 ? "activeLine" : ""}`}></div>
      <div className={`step ${step >= 3 ? "activeStep" : ""}`}>
        {step === 3 ? (
          <RadioButtonUnchecked classes={{ root: classes.circle }} />
        ) : (
          ""
        )}
        <div className="number">
          <span>3</span>
        </div>
      </div>
      <div className={`line ${step > 3 ? "activeLine" : ""}`}></div>
      <div className={`step ${step >= 4 ? "activeStep" : ""}`}>
        {step === 4 || step === 4.5 ? (
          <RadioButtonUnchecked classes={{ root: classes.circle }} />
        ) : (
          ""
        )}
        <div className="number">
          <span>4</span>
        </div>
      </div>
      <div className={`line ${step >= 5 ? "activeLine" : ""}`}></div>
      <div className={`step ${step >= 5 ? "activeStep" : ""}`}>
        {step === 5 ? (
          <RadioButtonUnchecked classes={{ root: classes.circle }} />
        ) : (
          ""
        )}
        <div className="number">
          <span>5</span>
        </div>
      </div>
      <div className={`line ${step > 5 ? "activeLine" : ""}`}></div>
      <div className={`step ${step >= 6 ? "activeStep" : ""}`}>
        {step === 6 ? (
          <RadioButtonUnchecked classes={{ root: classes.circle }} />
        ) : (
          ""
        )}
        <div className="number">
          <span>6</span>
        </div>
      </div>
      <div className={`line ${step > 6 ? "activeLine" : ""}`}></div>
      <div className={`step ${step > 6 ? "activeStep" : ""}`}>
        {step >= 7 ? (
          <RadioButtonUnchecked classes={{ root: classes.circle }} />
        ) : (
          ""
        )}
        <div className="number">
          <span>7</span>
        </div>
      </div>
      {/* <div className={`line ${step > 5 ? "activeLine" : ""}`}></div>
      <div
        className={`step ${step > 5 ? "activeStep" : ""}`}
        style={
          step >= 6
            ? {
                border: "2px solid transparent",
              }
            : {}
        }>
        <div className="number">
          <span>6</span>
        </div>
      </div> */}
    </div>
  );
}

function mapStateToProps(state) {
  return {};
}

const styles = (theme) => ({
  circle: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    color: theme.colors.background.stepActive,
    fontSize: 42,
  },
  trackerContainer: {
    maxWidth: 700,
    width: "90%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    margin: "0 auto",
    padding: "42px 0",

    "& .step": {
      width: 35,
      height: 32,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "50%",
      position: "relative",
      "& .number": {
        color: theme.colors.text.inactive,
        borderRadius: "50%",
        background: theme.colors.background.inactive,

        "& span": {
          height: 24,
          width: 24,
          textAlign: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 14,
          fontFamily: "Dm Sans, sans-serif",
          fontWeight: 600,
        },
      },

      "&.activeStep": {
        borderColor: `${theme.colors.background.stepActive} !important`,
        color: theme.colors.text.textOnRed,

        "& .number": {
          background: theme.colors.background.stepActive,
          color: theme.colors.text.textOnRed,
        },
      },
    },
    "& .line": {
      background: theme.colors.background.inactive,
      height: 2,
      width: 110,
      "&.activeLine": {
        background: theme.colors.background.stepActive,
      },
    },
  },
});

export default withStyles(styles)(
  connect(mapStateToProps, null)(StepTrackerCorporate)
);
